// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__tIGJE","pregunta":"styles_pregunta__D0_Gv","respuesta":"styles_respuesta__sbBHG"};